// @ts-nocheck
import { getLegacyBridge } from "./state";
import { closeSystemSettingsModal, openSystemSettingsModal } from "./system-settings";

let storageSettingsFeatureInitialized = false;

function legacyMethod(name: string, ...args: any[]): any {
  const method = getLegacyBridge().methods[name];
  if (typeof method !== "function") {
    throw new Error("Legacy method " + name + " is not initialized");
  }
  return method(...args);
}

function closePromptPopover(): void { legacyMethod("closePromptPopover"); }

async function refreshSettings() {}
function populateSettingsForm(settings: any) {
  void settings;
}

function openSettingsModal() {
  closePromptPopover();
  openSystemSettingsModal("notifications");
}

function closeSettingsModal() {
  closeSystemSettingsModal();
}

async function saveSettings() {}
async function chooseStorageDirectory(_input: any, _button: any) {}

export function initStorageSettingsFeature() {
  if (storageSettingsFeatureInitialized) return;
  storageSettingsFeatureInitialized = true;
  Object.assign(getLegacyBridge().methods, {
    refreshSettings,
    populateSettingsForm,
    openSettingsModal,
    closeSettingsModal,
    saveSettings,
    chooseStorageDirectory,
  });
}
